<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="3" lg="2" class="pb-0">
      <FilterSearch :fetchData="fetchItems" />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchItems" dateRange />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterAutocomplete
        :fetchData="fetchItems"
        :items="categories"
        item-text="name"
        type="categoryIds"
        value="id"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ItemListFilters',

  components: {
    FilterDates,
    FilterSearch,
    FilterAutocomplete,
  },

  computed: {
    ...mapGetters(['isLoading', 'categories']),
  },

  methods: {
    ...mapActions(['fetchItems', 'fetchCategories']),
  },

  mounted() {
    this.fetchCategories()
  },
}
</script>
